import palette from 'constants/palette'
import React from 'react'

const DEFAULT_SIZE = 96

type Props = {
  size?: number
  fillColor?: string
}

// Decorative "you're live" success illustration — filled spearmint circle + white
// ribbon-fold check. aria-hidden; the page headline conveys the meaning.
// Ribbon-fold paths adapted from the former Icons/SuccessCheckmark.tsx (a 0-consumer
// orphan removed in this change) with hexes mapped to palette tokens (dark depth path
// → grey90 @0.3, imperceptible over teal).
const CheckCircleFilled = ({
  size = DEFAULT_SIZE,
  fillColor = palette.spearmint,
}: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 196 196"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="98" cy="98" r="98" fill={fillColor} />
    <path
      d="M55.2723 64.68L36.146 83.6232C34.578 85.2253 35.4927 87.4266 36.146 88.3271C54.178 105.444 90.7124 140.071 92.594 141.639C94.4756 143.207 97.5594 142.292 98.866 141.639L194.906 46.7751V38.1511L192.162 33.8391C186.282 29.1352 174.365 19.4922 173.738 18.5514C173.111 17.6106 171.909 18.1594 171.386 18.5514C146.559 43.7701 96.6708 94.5994 95.73 96.1674C94.7892 97.7354 93.2474 96.8208 92.594 96.1674C82.5327 85.8447 60.7603 64.876 59.5843 64.288C58.0163 63.504 56.4483 64.288 55.2723 64.68Z"
      fill={palette.grey20}
    />
    <path
      d="M54.8807 65.072L39.2007 80.36L95.2567 131.32L192.081 34.104L172.481 18.032C147.915 43.2507 96.1975 96.2752 95.2567 97.216C94.3159 98.1568 93.2967 97.608 92.9047 97.216C83.2354 87.2853 63.1911 66.9536 60.3687 65.072C57.5463 63.1904 55.534 64.288 54.8807 65.072Z"
      fill={palette.white}
    />
    <path
      opacity="0.3"
      d="M186.2 54.8801L106.232 134.456C112.504 129.36 191.062 66.5403 190.512 65.0721C189.336 61.9361 188.16 58.4081 186.2 54.8801Z"
      fill={palette.grey90}
    />
  </svg>
)

export default CheckCircleFilled
